import {
  Checkbox,
  FormControlLabel,
  Grid,
  TextField as TextFieldMU,
  makeStyles
} from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import { NumberFormatCustom } from 'src/components/ui/NumberField'
import TextField from 'src/components/ui/TextField'
import Ubox from 'src/components/ui/Ubox'

type Props = {
  control?: any
  errors?: any
  register?: any
  command?: any
  handleItemValue?: any
  isPJ?: boolean
  handleChechedItem?: any
  editarDadosBancarios?: any
}

const useStyles = makeStyles(theme => ({
  formControl2: {
    top: '16px'
  },
  [theme.breakpoints.down('md')]: {}
}))

export default function DadosBasicos({
  control,
  errors,
  register,
  command,
  handleItemValue,
  isPJ,
  handleChechedItem,
  editarDadosBancarios
}: Props) {
  return (
    <Grid container spacing={1}>
      <Ubox render={!isPJ && command.cpfCnpj.length > 0}>
        <Alert severity="info">
          {' '}
          O nome e {isPJ ? 'CNPJ' : 'CPF'} devem ser os mesmos dos dados
          bancários.
        </Alert>
      </Ubox>
      <Grid item xs={12} md={12}>
        <TextField
          inputRef={register}
          erro={errors}
          name="name"
          value={command.name}
          disabled={!isPJ && command.name.length > 0}
          placeholder={isPJ ? 'Nome do representante' : 'Nome do recebedor'}
          label={isPJ ? 'Nome do representante *' : 'Nome do recebedor *'}
          InputLabelProps={{
            shrink: true
          }}
          id="input-nome-dados-basicos"
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <TextField
          erro={errors}
          name="document"
          placeholder="000.000.000-00"
          label={isPJ ? 'CPF do representante *' : 'CPF do titular *'}
          hiddenLabel
          control={control}
          mask="999.999.999-99"
          disabled={
            !!editarDadosBancarios || (!isPJ && command.document.length > 0)
          }
          InputLabelProps={{
            shrink: true
          }}
          id="input-document-dados-basicos"
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          erro={errors}
          control={control}
          name="birthdate"
          label="Data de nascimento *"
          placeholder="DD/MM/AAAA"
          mask="99/99/9999"
          InputLabelProps={{
            shrink: true
          }}
          id="input-birthdate-dados-basicos"
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <TextField
          control={control}
          erro={errors}
          inputRef={register}
          inputProps={{ maxLength: 64 }}
          name="email"
          label="E-mail *"
          placeholder="grace.l@example.com"
          InputLabelProps={{
            shrink: true
          }}
          id="input-email-dados-basicos"
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          size="medium"
          erro={errors}
          type="tel"
          maskTelCel
          control={control}
          inputProps={{ maxLength: 100, minLength: 10 }}
          name="phoneNumbers"
          label="Telefone *"
          placeholder="(00) 00000-0000"
          InputLabelProps={{
            shrink: true
          }}
          id="input-phone-numbers-dados-basicos"
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <TextField
          control={control}
          erro={errors}
          inputRef={register}
          name="professionalOccupation"
          label="Ocupação profissional *"
          placeholder="Ex: Médico"
          InputLabelProps={{
            shrink: true
          }}
          id="input-professional-occupation-dados-basicos"
        />
      </Grid>

      {!isPJ && (
        <Grid item xs={12} md={6}>
          <TextField
            control={control}
            erro={errors}
            inputRef={register}
            name="siteUrl"
            label="Site ou rede social *"
            placeholder="https://site-ou-rede-social.com/..."
            InputLabelProps={{
              shrink: true
            }}
            id="input-site-url-dados-basicos"
          />
        </Grid>
      )}

      <Grid item xs={12} md={6}>
        <TextFieldMU
          data-cy="monthlyIncome"
          variant="outlined"
          fullWidth
          margin="normal"
          label="Sua renda *"
          error={!!errors.monthlyIncome}
          helperText={errors.monthlyIncome?.message}
          onFocus={e => e.target.select()}
          value={command.monthlyIncome}
          defaultValue={command.monthlyIncome}
          InputProps={{
            inputComponent: NumberFormatCustom as any
          }}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            const value = event.target.value
            handleItemValue('monthlyIncome', value)
          }}
        />
      </Grid>
      {isPJ && (
        <>
          {/* <Grid item xs={12} md={12}>
            <TextField
              control={control}
              erro={errors}
              inputRef={register}
              name="motherName"
              label="Nome da mãe *"
            />
          </Grid> */}

          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={command.selfDeclaredLegalRepresentative}
                  color="primary"
                  name="selfDeclaredLegalRepresentative"
                  onChange={handleChechedItem}
                  id="check-self-declared-legal-representative"
                />
              }
              label="Se identifica como representante legal do CNPJ? *"
            />
            {errors?.selfDeclaredLegalRepresentative && (
              <p className="MuiFormHelperText-root MuiFormHelperText-contained Mui-error">
                {errors?.selfDeclaredLegalRepresentative?.message}
              </p>
            )}
            {/* error={errors.selfDeclaredLegalRepresentative} */}
          </Grid>
        </>
      )}
    </Grid>
  )
}
